const AccessGroupsPrefix = require('./prefixes/AccessGroupsPrefix');
const AssetCategoriesPrefix = require('./prefixes/AssetCategoriesPrefix');
const AssetsPrefix = require('./prefixes/AssetsPrefix');
const AssetTagsPrefix = require('./prefixes/AssetTagsPrefix');
const AssetTypesPrefix = require('./prefixes/AssetTypesPrefix');
const CollectionsPrefix = require('./prefixes/CollectionsPrefix');
const NotificationsPrefix = require('./prefixes/NotificationsPrefix');
const PlatformsPrefix = require('./prefixes/PlatformsPrefix');
const SavedViewsPrefix = require('./prefixes/SavedViewsPrefix');
const UserDownloadRequestsPrefix = require('./prefixes/UserDownloadRequestsPrefix');
const UsersPrefix = require('./prefixes/UsersPrefix');
const UserUploadsPrefix = require('./prefixes/UserUploadsPrefix');

module.exports = {
	AccessGroupsPrefix,
	AssetCategoriesPrefix,
	AssetsPrefix,
	AssetTagsPrefix,
	AssetTypesPrefix,
	CollectionsPrefix,
	NotificationsPrefix,
	PlatformsPrefix,
	SavedViewsPrefix,
	UserDownloadRequestsPrefix,
	UsersPrefix,
	UserUploadsPrefix
};